export const environment = {
  production: true,
  apiProtocol: "https://",
  apiDomain: "api-preview.flowmaps.com",
};
